import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CdkTableModule } from '@angular/cdk/table';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatStepperModule} from '@angular/material/stepper';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';

import { FuseSharedModule } from '@fuse/shared.module';

import { ComponentsModule} from '../../../../components/components.module';
import {ProcessDialogComponent } from './process-dialog.component';

import { PhoenixPipesModule } from '../../../../pipes/pipes';
import { SharedModule } from '../../../../shared/shared.module';
import { WidgetModule } from '../../../widgets/widget.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';

@NgModule({
    declarations: [
        ProcessDialogComponent,
    ],
    imports: [
        CdkTableModule,
        MatIconModule,
        MatButtonModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatSidenavModule,
        MatTableModule,
        MatInputModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSortModule,
        MatToolbarModule,
        MatStepperModule,
        WidgetModule,
        GridsterModule,
        DynamicModule,
        ComponentsModule,
        FuseSharedModule,
        SharedModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule.forRoot(),
    ],
    providers: [],
    exports: []
})

export class ProcessDialogModule
{
}
